import { makeStyles } from '@material-ui/core/styles';

export function useTableActionStyles() {
    const useStyles = makeStyles((theme) => ({
        menuItem: {
            gap: 10,
            display: 'flex',
            fontWeight: 500,
            color: '#000',
            '&:hover': {
                textDecoration: 'none',
            },
        }
    }));

    const classes = useStyles();

    return {
        classes,
    };
}